import React, { useEffect, useState } from 'react';
import MixGoatLogo from '../MixGoatLogo';
import '../Onboarding/OnboardingFlow.scss';
import './ForceUpgradeScreen.scss';
import { getVersionCheck } from './versionCheck';

const DOWNLOAD_FALLBACK = 'https://mixgoat.com/download';

const DownloadIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
    </svg>
);

const AlertIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
);

const ForceUpgradeScreen = () => {
    const [info, setInfo] = useState(null);

    useEffect(() => {
        let cancelled = false;
        // Shared, memoized check (also feeds UpdateNudgeBanner). Fails open.
        getVersionCheck().then((result) => {
            if (cancelled) return;
            if (result?.forceUpgrade) setInfo(result);
        });
        return () => { cancelled = true; };
    }, []);

    if (!info) return null;

    const downloadUrl = info.downloadUrl || DOWNLOAD_FALLBACK;
    const handleDownload = () => {
        if (window.electron?.openUrl) {
            window.electron.openUrl(downloadUrl);
        } else {
            window.open(downloadUrl, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <div className="ob-overlay fu-overlay">
            <div className="ob-bg-gradient" />
            <div className="ob-bg-noise" />

            <div className="ob-card fu-card">
                <div className="fu-logo-wrap">
                    <MixGoatLogo width={72} height={72} />
                </div>

                <div className="ob-step-icon fu-alert-icon">
                    <AlertIcon />
                </div>

                <h1 className="ob-step-title">Update required</h1>
                <p className="ob-step-subtitle fu-subtitle">
                    This version of MixGoat is no longer supported. Please download the
                    latest version from our website to keep using the app.
                </p>

                <div className="fu-version-box">
                    <div className="fu-version-row">
                        <span className="fu-version-label">Your version</span>
                        <span className="fu-version-value">{info.version || 'Unknown'}</span>
                    </div>
                    {info.minimumVersion && (
                        <div className="fu-version-row">
                            <span className="fu-version-label">Minimum required</span>
                            <span className="fu-version-value fu-version-highlight">{info.minimumVersion}</span>
                        </div>
                    )}
                </div>

                <button className="ob-btn ob-btn-primary ob-btn-large fu-btn" onClick={handleDownload}>
                    <DownloadIcon />
                    Download latest version
                </button>

                <p className="fu-footer-link">
                    Or visit <span className="fu-link" onClick={handleDownload}>{downloadUrl.replace(/^https?:\/\//, '')}</span>
                </p>
            </div>
        </div>
    );
};

export default ForceUpgradeScreen;
